<template>
    <el-radio-group v-model="showButtonGroup" :size="size" @change="handleChange" :border="border">
        <el-radio-button v-for="item in options" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
    </el-radio-group>
</template>

<script>
export default {
    name: 'ButtonGroup',
    props: {
        buttonGroup: {
            // type: String,
            type: Number,
        },
        size: {
            type: String,
            default: 'mini'
        },
        border: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            showButtonGroup: null,
        }
    },
    methods: {
        handleChange(val) {
            this.$emit('buttonGroupChange',val)
        }
    },
    watch: {
        buttonGroup: {
            immediate:true,
            handler(n) {
                this.showButtonGroup = n
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/ButtonGroup.vue